import StandbyOverlay from "client/components/layout/StandbyOverlay";
import { Save } from "client/interfaces/Responses";
import { IProjectInfo } from "common/lib";
import { openSaveFile } from "./ScenarioProjectUtils";
import { IAppScenario } from "../api/GQL/scenarios/gql";
import GQLAppScenarios from "../api/GQL/scenarios/GQLAppScenarios";

export default class ScenarioUtils
{
	static loadScenario(scenario: IAppScenario)
	{
		if(!scenario.id) return;

		StandbyOverlay.startStandbyMode("Loading Scenario...");

		GQLAppScenarios.getScenarioProject(scenario.id)
			.then(project => 
			{
				const saveData: Save = {
					url: scenario.currentRelease?.projectSaveFile?.file.fileUrl || "",
					project: project.id,
					revisionId: scenario.currentRelease?.projectSaveFile?.id || "",
				} as Save;

				const projectInfo: IProjectInfo = {
					_id: project.id,
					name: project.name || "",
				} as IProjectInfo;

				openSaveFile(saveData, projectInfo);
			})
			.catch(error => 
			{
				console.error("Error loading scenario:", error);
			})
			.finally(() => 
			{
				StandbyOverlay.stopStandbyMode();
			});
	}
}